/*
 * Emma's Choice product page behaviour. Loaded on product pages only.
 *
 * Picking another colour makes the gallery slide to that colour's photo,
 * but on a phone the gallery sits above the picker, out of view. Scroll
 * back up to it, as the reference store does. Sizes are left alone: after
 * choosing a size the shopper wants the add to cart button, not the photos.
 */
(() => {
  const isColourInput = (target) =>
    target instanceof HTMLInputElement && target.type === 'radio' && /^colou?r/i.test(target.name);

  const stickyHeaderHeight = () => {
    const header = document.querySelector('.header-section');
    if (!header || getComputedStyle(header).position !== 'sticky') return 0;
    return header.offsetHeight;
  };

  document.addEventListener('change', (event) => {
    const input = event.target;
    if (!isColourInput(input)) return;

    const picker = input.closest('variant-picker');
    if (!picker || input.closest('product-card, quick-add-dialog, quick-add-component')) return;

    const gallery = picker.closest('.shopify-section')?.querySelector('media-gallery');
    if (!gallery) return;

    // Desktop: the photos sit next to the picker and are already in view.
    if (gallery.getBoundingClientRect().bottom > picker.getBoundingClientRect().top) return;

    const offset = stickyHeaderHeight();
    const top = gallery.getBoundingClientRect().top;
    if (top >= offset) return; // top of the gallery is already in view

    const reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    window.scrollTo({ top: window.scrollY + top - offset, behavior: reduceMotion ? 'auto' : 'smooth' });
  });
})();
